import { useState, useEffect, useRef } from "react";
const API = "/api";
export default function MisDocumentos() {
  const [archivos, setArchivos] = useState([]);
  const [sesiones, setSesiones] = useState([]);
  const [sesionActual, setSesionActual] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [pregunta, setPregunta] = useState("");
  const [cargando, setCargando] = useState(false);
  const [vista, setVista] = useState("chat");
  const [instrucciones, setInstrucciones] = useState("");
  const [informe, setInforme] = useState("");
  const [generando, setGenerando] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => { cargarArchivos(); cargarSesiones(); }, []);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [mensajes]);

  const cargarArchivos = async () => {
    const r = await fetch(`${API}/chunks/files`);
    setSesiones(await (await fetch(`${API}/chunks/sessions`)).json());
    setArchivos(await r.json());
  };

  const cargarSesiones = async () => {
    const r = await fetch(`${API}/chunks/sessions`);
    setSesiones(await r.json());
  };

  const nuevaSesion = async () => {
    const r = await fetch(`${API}/chunks/sessions`, {
      method: "POST", headers: {"Content-Type":"application/json"},
      body: JSON.stringify({title: "Chat " + new Date().toLocaleString()})
    });
    const s = await r.json();
    await cargarSesiones();
    setSesionActual(s);
    setMensajes([]);
  };

  const abrirSesion = async (s) => {
    setSesionActual(s);
    const r = await fetch(`${API}/chunks/sessions/${s.id}/messages`);
    const msgs = await r.json();
    setMensajes(msgs.map(m => ({role: m.role, text: m.content})));
  };

  const eliminarSesion = async (id) => {
    if (!window.confirm("Eliminar conversacion?")) return;
    await fetch(`${API}/chunks/sessions/${id}`, {method: "DELETE"});
    if (sesionActual?.id === id) { setSesionActual(null); setMensajes([]); }
    cargarSesiones();
  };

  const eliminarArchivo = async (filename) => {
    if (!window.confirm(`Eliminar ${filename}?`)) return;
    await fetch(`${API}/chunks/files/${encodeURIComponent(filename)}`, {method: "DELETE"});
    cargarArchivos();
  };

  const generarInforme = async () => {
    if (!instrucciones.trim()) return;
    setGenerando(true);
    setInforme("");
    try {
      const r = await fetch(`${API}/chunks/ask`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({question: instrucciones + " informe gerencial ejecutivo"})
      });
      const data = await r.json();
      setInforme(data.answer || "Sin respuesta");
    } catch(e) { setInforme("Error al generar"); }
    setGenerando(false);
  };

  const descargarPDF = () => {
    const ventana = window.open("", "_blank");
    ventana.document.write(`
      <html><head><title>Informe Gerencial</title>
      <style>body{font-family:Arial,sans-serif;padding:40px;max-width:800px;margin:0 auto;color:#1a1a2e;}
      h1{color:#2c3e50;border-bottom:2px solid #6c63ff;padding-bottom:10px;}
      pre{white-space:pre-wrap;font-family:Arial,sans-serif;line-height:1.8;}</style></head>
      <body><h1>Informe Gerencial Ejecutivo</h1>
      <p style="color:#666">Generado el ${new Date().toLocaleDateString()}</p>
      <pre>${informe}</pre></body></html>
    `);
    ventana.document.close();
    ventana.print();
  };

  const preguntar = async () => {
    if (!pregunta.trim() || cargando || !sesionActual) return;
    const q = pregunta;
    setPregunta("");
    setMensajes(m => [...m, {role:"user", text:q}]);
    setCargando(true);
    await fetch(`${API}/chunks/sessions/${sesionActual.id}/messages`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({role:"user", content:q})
    });
    try {
      const r = await fetch(`${API}/chunks/ask`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({question:q})
      });
      const data = await r.json();
      const resp = data.answer || "Sin respuesta";
      setMensajes(m => [...m, {role:"assistant", text:resp}]);
      await fetch(`${API}/chunks/sessions/${sesionActual.id}/messages`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({role:"assistant", content:resp})
      });
    } catch(e) {
      setMensajes(m => [...m, {role:"assistant", text:"Error"}]);
    }
    setCargando(false);
  };

  return (
    <div style={{display:"flex",height:"calc(100vh - 80px)",boxSizing:"border-box"}}>
      <div style={{width:"240px",background:"#1e1e2e",padding:"16px",overflowY:"auto",flexShrink:0,borderRight:"1px solid #2a2a3e"}}>
        <button onClick={nuevaSesion} style={{width:"100%",padding:"10px",background:"#6c63ff",color:"white",border:"none",borderRadius:"8px",cursor:"pointer",marginBottom:"16px",fontWeight:"bold"}}>+ Nuevo chat</button>
        <div style={{marginBottom:"16px"}}>
          <p style={{color:"#666",fontSize:"11px",marginBottom:"8px"}}>CONVERSACIONES</p>
          {sesiones.map(s => (
            <div key={s.id} onClick={()=>abrirSesion(s)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",borderRadius:"8px",cursor:"pointer",background:sesionActual?.id===s.id?"#2a2a3e":"transparent",marginBottom:"4px"}}>
              <span style={{fontSize:"12px",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#e0e0e0"}}>💬 {s.title}</span>
              <button onClick={e=>{e.stopPropagation();eliminarSesion(s.id);}} style={{background:"transparent",color:"#c0392b",border:"none",cursor:"pointer",fontSize:"14px"}}>✕</button>
            </div>
          ))}
        </div>
        <p style={{color:"#666",fontSize:"11px",marginBottom:"8px"}}>ARCHIVOS</p>
        {archivos.map((a,i) => (
          <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 8px",background:"#2a2a3e",borderRadius:"6px",marginBottom:"4px"}}>
            <span style={{fontSize:"11px",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"#e0e0e0"}}>📄 {a.filename}</span>
            <button onClick={()=>eliminarArchivo(a.filename)} style={{background:"transparent",color:"#c0392b",border:"none",cursor:"pointer",fontSize:"12px"}}>✕</button>
          </div>
        ))}
      </div>

      <div style={{flex:1,display:"flex",flexDirection:"column",background:"#16161e"}}>
        <div style={{padding:"16px 20px",borderBottom:"1px solid #2a2a3e",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <h2 style={{margin:0,fontSize:"16px"}}>📂 Mis Documentos</h2>
            <p style={{margin:"4px 0 0",color:"#666",fontSize:"12px"}}>{vista==="chat" ? (sesionActual ? sesionActual.title : "Selecciona o crea un chat") : "Informe Gerencial"}</p>
          </div>
          <div style={{display:"flex",gap:"8px"}}>
            <button onClick={()=>setVista("chat")} style={{padding:"8px 16px",borderRadius:"8px",border:"none",cursor:"pointer",background:vista==="chat"?"#6c63ff":"#2a2a3e",color:"white",fontSize:"13px"}}>💬 Chat</button>
            <button onClick={()=>setVista("informe")} style={{padding:"8px 16px",borderRadius:"8px",border:"none",cursor:"pointer",background:vista==="informe"?"#6c63ff":"#2a2a3e",color:"white",fontSize:"13px"}}>📊 Informe</button>
          </div>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"20px",display:"flex",flexDirection:"column",gap:"16px"}}>
          {vista==="informe" && (
            <div style={{maxWidth:"800px",margin:"0 auto",width:"100%"}}>
              <div style={{background:"#1e1e2e",borderRadius:"12px",padding:"20px",marginBottom:"20px"}}>
                <h3 style={{marginBottom:"12px",color:"#a0a0b0",fontSize:"14px"}}>INSTRUCCIONES PARA EL INFORME</h3>
                <textarea value={instrucciones} onChange={e=>setInstrucciones(e.target.value)} placeholder="Ejemplo: Resume los principales indicadores de compras de camaron del 2026, destacando montos, proveedores y tendencias..." style={{width:"100%",minHeight:"100px",padding:"12px",borderRadius:"8px",border:"1px solid #444",background:"#2a2a3e",color:"white",fontSize:"14px",resize:"vertical",boxSizing:"border-box"}} />
                <div style={{display:"flex",gap:"12px",marginTop:"12px"}}>
                  <button onClick={generarInforme} disabled={generando} style={{padding:"10px 24px",background:"#6c63ff",color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontWeight:"bold"}}>{generando?"Generando...":"📊 Generar Informe"}</button>
                  {informe && <button onClick={descargarPDF} style={{padding:"10px 24px",background:"#27ae60",color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontWeight:"bold"}}>📄 Descargar PDF</button>}
                </div>
              </div>
              {informe && (
                <div style={{background:"#1e1e2e",borderRadius:"12px",padding:"28px",lineHeight:"1.8",color:"#e0e0e0",fontSize:"15px"}} dangerouslySetInnerHTML={{__html: informe.replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>").replace(/^## (.+)$/gm,"<h2 style='color:#6c63ff;border-bottom:1px solid #2a2a3e;padding-bottom:8px'>$1</h2>").replace(/^### (.+)$/gm,"<h3 style='color:#a0a0b0'>$1</h3>").replace(/^- (.+)$/gm,"<li style='margin-bottom:4px'>$1</li>").replace(/\n/g,"<br/>")}} />
              )}
            </div>
          )}
          {vista==="chat" && !sesionActual && (
            <div style={{textAlign:"center",color:"#555",marginTop:"80px"}}>
              <div style={{fontSize:"48px",marginBottom:"12px"}}>📂</div>
              <p>Crea un nuevo chat para empezar</p>
              <button onClick={nuevaSesion} style={{marginTop:"12px",padding:"10px 24px",background:"#6c63ff",color:"white",border:"none",borderRadius:"8px",cursor:"pointer"}}>+ Nuevo chat</button>
            </div>
          )}
          {vista==="chat" && mensajes.map((m,i) => (
            <div key={i} style={{display:"flex",justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
              <div style={{maxWidth:"75%",padding:"12px 16px",borderRadius:m.role==="user"?"18px 18px 4px 18px":"18px 18px 18px 4px",background:m.role==="user"?"#6c63ff":"#2a2a3e",color:"white",fontSize:"14px",lineHeight:"1.6"}}>
                {m.text}
              </div>
            </div>
          ))}
          {vista==="chat" && cargando && <div style={{display:"flex"}}><div style={{background:"#2a2a3e",borderRadius:"18px",padding:"12px 16px",color:"#666"}}>Consultando...</div></div>}
          <div ref={bottomRef} />
        </div>
        {sesionActual && (
          <div style={{padding:"16px 20px",borderTop:"1px solid #2a2a3e",display:"flex",gap:"12px"}}>
            <input value={pregunta} onChange={e=>setPregunta(e.target.value)} onKeyDown={e=>e.key==="Enter"&&preguntar()} placeholder="Escribe tu pregunta..." style={{flex:1,padding:"12px 16px",borderRadius:"24px",border:"1px solid #444",background:"#2a2a3e",color:"white",fontSize:"14px",outline:"none"}} />
            <button onClick={preguntar} disabled={cargando} style={{background:"#6c63ff",color:"white",border:"none",borderRadius:"50%",width:"44px",height:"44px",cursor:"pointer",fontSize:"18px"}}>➤</button>
          </div>
        )}
      </div>
    </div>
  );
}
